// extracted by mini-css-extract-plugin
export default {"Footer":"Footer-module__Footer--Iw3L2","link":"Footer-module__link--Eow65"};